/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DevicePlanChangeAction } from './DevicePlanChangeAction';
import {
    DevicePlanChangeActionFromJSON,
    DevicePlanChangeActionFromJSONTyped,
    DevicePlanChangeActionToJSON,
    DevicePlanChangeActionToJSONTyped,
} from './DevicePlanChangeAction';

/**
 * 
 * @export
 * @interface DevicePlanChangeOnAzure
 */
export interface DevicePlanChangeOnAzure {
    /**
     * 
     * @type {string}
     * @memberof DevicePlanChangeOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DevicePlanChangeOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof DevicePlanChangeOnAzure
     */
    mac_address: string;
    /**
     * 
     * @type {DevicePlanChangeAction}
     * @memberof DevicePlanChangeOnAzure
     */
    action: DevicePlanChangeAction;
    /**
     * 
     * @type {string}
     * @memberof DevicePlanChangeOnAzure
     */
    requested_by: string;
    /**
     * 
     * @type {number}
     * @memberof DevicePlanChangeOnAzure
     */
    created_at: number;
    /**
     * 
     * @type {boolean}
     * @memberof DevicePlanChangeOnAzure
     */
    completed: boolean;
    /**
     * 
     * @type {number}
     * @memberof DevicePlanChangeOnAzure
     */
    completed_at?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DevicePlanChangeOnAzure
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevicePlanChangeOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof DevicePlanChangeOnAzure
     */
    _ts: number;
}



/**
 * Check if a given object implements the DevicePlanChangeOnAzure interface.
 */
export function instanceOfDevicePlanChangeOnAzure(value: object): value is DevicePlanChangeOnAzure {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('mac_address' in value) || value['mac_address'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('requested_by' in value) || value['requested_by'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function DevicePlanChangeOnAzureFromJSON(json: any): DevicePlanChangeOnAzure {
    return DevicePlanChangeOnAzureFromJSONTyped(json, false);
}

export function DevicePlanChangeOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevicePlanChangeOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'object_type': json['object_type'],
        'mac_address': json['mac_address'],
        'action': DevicePlanChangeActionFromJSON(json['action']),
        'requested_by': json['requested_by'],
        'created_at': json['created_at'],
        'completed': json['completed'],
        'completed_at': json['completed_at'] == null ? undefined : json['completed_at'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function DevicePlanChangeOnAzureToJSON(json: any): DevicePlanChangeOnAzure {
    return DevicePlanChangeOnAzureToJSONTyped(json, false);
}

export function DevicePlanChangeOnAzureToJSONTyped(value?: DevicePlanChangeOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'object_type': value['object_type'],
        'mac_address': value['mac_address'],
        'action': DevicePlanChangeActionToJSON(value['action']),
        'requested_by': value['requested_by'],
        'created_at': value['created_at'],
        'completed': value['completed'],
        'completed_at': value['completed_at'],
        'notes': value['notes'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

